// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3G9-c","imageUploader":"EGiftCard_imageUploader__1cdpL"};